import React, { Component } from 'react'
import { connect } from 'react-redux'
import io from 'socket.io-client'

import WebSocketEventHandler from './WebSocketEventHandler'
import { addFirewallD } from '../actions/actions'

let socket = io('http://portfolio.jamalmahboob.com:5000')

class WebSocket extends Component {

    constructor(props) {
        super(props)
        this.props
    }

    componentDidMount() {
        socket.on('message', data => {
            this.props.dispatch( addFirewallD(data) )
        }) 
    }

    render() {
        return(
            <WebSocketEventHandler socket={socket} />
        )
    }
}

const mapStateToProps = state => {
    return {
        messages: state.messages
    }
}

export default connect(mapStateToProps)(WebSocket)



// WEBPACK FOOTER //
// ./src/components/WebSocket.js